import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Compass } from 'lucide-react';

export default function PlannerDiscover() {
  return <Link className="planner-discover" to="/">
    <span className="planner-discover-icon"><Compass size={22} aria-hidden /></span>
    <span>Weitere Events entdecken</span>
    <ArrowRight className="planner-discover-arrow" size={20} aria-hidden />
  </Link>;
}
